<template>
<div>
    <b-form @submit.prevent="DELRow">
        <b-row>
            <b-col>
                <div class="card-wrapper">
                    <card>
                        <b-row>
                            <b-col sm="4"> NAMA</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{listRow.CONm}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4"> NO KAD PENGENALAN</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{listRow.NoKP}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4"> KATEGORI</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{listRow.Kategori}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4"> AGENSI</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{listRow.Agensi}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4"> PEGAWAI PENGIRA</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{listRow.PegPengira}}
                            </b-col>
                        </b-row>
                        <div class="pl-lg-4">
                            <b-row>
                                <b-col md="12" class="text-md-right">
                                    <b-button variant="danger" @click="batal()">BATAL</b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </card>
                </div>
            </b-col>
        </b-row>
        <!-- </b-container> -->
    </b-form>
</div>
</template>

<script>
import swal from "sweetalert2";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
export default {
    props: {
        listRow: {
            type: Object
        },
    },
        data() {
        return {
            SenaraiPenjawatAwam: {
                    CONm: "shuk",
                    NoKP: "2000101010101",
                    NoMohon: "M-001",
                    Agensi: "KPM",
                    PegPengira: "AKMAL"
                },
        }},
    methods: {

        batal() {
            this.$emit("batal");
        },
    },
    computed: {
    },
}
</script>
